import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Menu } from '../shapes';


const MenuSvg = (props) => (
  <g>
    <IconBounds />
    <Menu {...props} />
  </g>
);

MenuSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

MenuSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default MenuSvg;
